import React, { PropsWithChildren } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import MessageInput, { MessageInputDataType } from './MessageInput';

function AccordionLevel({
  title,
  subtitle,
  flagLabel,
  defaultValue,
  index,
  id,
  type,
  error,
  children,
}: PropsWithChildren<{
  title: string;
  subtitle?: string;
  flagLabel: string;
  index: number;
  defaultValue?: string | null;
  type: MessageInputDataType;
  id: string;
  error?: boolean;
}>) {
  return (
    <Accordion.Item eventKey={index.toString()}>
      <Accordion.Header
        style={{ marginTop: 0 }}
        data-cy={`accordion-header-${type}-${id}`}
      >
        <span
          style={{
            paddingLeft: '0.5rem',
            display: 'flex',
            flexDirection: 'column',
            fontWeight: 700,
            gap: 5,
          }}
          className={error ? 'text-danger' : undefined}
        >
          {title}
          {subtitle && (
            <span style={{ fontSize: '0.8rem', fontWeight: 500 }}>
              {subtitle}
            </span>
          )}
        </span>
      </Accordion.Header>
      <Accordion.Body
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 5,
        }}
      >
        {defaultValue && (
          <MessageInput
            label={flagLabel}
            defaultValue={defaultValue}
            type={type}
            multiline
            id={id}
          />
        )}
        {children}
      </Accordion.Body>
    </Accordion.Item>
  );
}

export default AccordionLevel;
